"use client";
import { useTranslation } from "@/lib/i18n";

import { Button } from "../ui/button";
import {
  Navbar as NavbarComponent,
  NavbarLeft,
  NavbarRight,
} from "../ui/navbar";
import { siteConfig } from "@/config/site";
import { ToggleTheme } from "../ui/toogle-theme";
import { ToggleLanguage } from "../ui/toggle-language";
import { useState } from "react";
import { MenuIcon, XIcon, ShieldCheckIcon } from "lucide-react";

const navLinks = (t: any) => [
  { label: t("navbar.features"), href: "#features" },
  { label: t("navbar.solutions"), href: "#solutions" },
  { label: t("navbar.frameworks"), href: "#frameworks" },
  { label: t("navbar.about"), href: "#about" },
];

export default function Navbar() {
  const { t } = useTranslation("common");
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 -mb-4 px-4 pb-4">
      <div className="fade-bottom absolute left-0 h-24 w-full bg-background/15 backdrop-blur-lg"></div>
      <div className="relative mx-auto max-w-container">
        <NavbarComponent>
          <NavbarLeft>
            <a
              href="/"
              className="flex items-center gap-2 text-xl font-normal font-cubic"
            >
              <ShieldCheckIcon className="h-6 w-6 text-aicompliance-foreground" />
              AI Compliance
            </a>
            <nav className="hidden md:flex items-center gap-6 ml-8">
              {navLinks(t).map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </NavbarLeft>
          <NavbarRight>
            <a href={siteConfig.signUp} className="hidden sm:inline text-sm">
              {t("navbar.sign_in")}
            </a>
            <Button variant="default" asChild>
              <a href={siteConfig.bookDemoUrl}>{t("navbar.book_demo")}</a>
            </Button>
            <ToggleTheme />
            <ToggleLanguage />
            <button
              className="md:hidden p-2"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="Toggle menu"
            >
              {mobileOpen ? (
                <XIcon className="h-5 w-5" />
              ) : (
                <MenuIcon className="h-5 w-5" />
              )}
            </button>
          </NavbarRight>
        </NavbarComponent>
        {/* Mobile menu */}
        {mobileOpen && (
          <nav className="md:hidden absolute top-full left-0 right-0 glass-5 rounded-xl p-4 mt-2 flex flex-col gap-3 animate-appear">
            {navLinks(t).map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm text-muted-foreground transition-colors hover:text-foreground py-2"
                onClick={() => setMobileOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <hr className="border-border/40" />
            <a href={siteConfig.signUp} className="text-sm py-2">
              {t("navbar.sign_in")}
            </a>
          </nav>
        )}
      </div>
    </header>
  );
}
